<div class="container zipDiv">
  <h2 class="text-center">Zip Code:</h2>
  &nbsp;&nbsp;
  <input type="number" [ngModel]="zip" (ngModelChange)="savezip($event)"/>
  &nbsp;&nbsp;
  <button type="submit" class="btn" (click)="onClick()">Get Quote</button>
</div>

